import React, { useEffect, useState, useCallback } from "react";
import API_BASE_URL from "../../../../Constants";
import SearchIcon from "@mui/icons-material/Search";

const History = () => {

    const [filteredCalls, setFilteredCalls] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const formatDate = (dateInput, isDateOnly = false) => {
        if (!dateInput) return "";
        try {
            const date = new Date(dateInput);
            const pad = (n) => n.toString().padStart(2, '0');
            const mm = pad(date.getMonth() + 1);
            const dd = pad(date.getDate());
            const yyyy = date.getFullYear();
            const formattedDate = `${mm}/${dd}/${yyyy}`;

            if (isDateOnly) return formattedDate;

            const hours = date.getHours();
            const minutes = pad(date.getMinutes());
            const ampm = hours >= 12 ? 'PM' : 'AM';
            const displayHours = hours % 12 || 12;

            return `${formattedDate} ${displayHours}:${minutes} ${ampm}`;
        } catch (error) {
            console.error("Invalid date format:", dateInput, error);
            return "";
        }
    };

    const fetchMobileDispatches = useCallback(async () => {
        try {
            setIsLoading(true);
            const response = await fetch(`${API_BASE_URL}/api/dispatch-records/all`, {
                credentials: "include",
            });
            if (!response.ok) throw new Error("Failed to fetch call history");

            const data = await response.json();
            setFilteredCalls(data);
        } catch (error) {
            console.error("Error fetching call history:", error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchMobileDispatches();
    }, []);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };


    return (
        <div className="mx-auto pl-4 pr-4 h-screen w-full">
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-2xl font-bold">Dispatch Records</h2>
                <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden">
                    <div className="px-3 py-2 text-gray-500 cursor-pointer">
                        <SearchIcon />
                    </div>
                    <input
                        type="text"
                        className="px-3 py-2 w-full outline-none"
                        placeholder="Search by Ticket ID"
                        value={searchQuery}
                        onChange={handleSearchChange}
                        readOnly={isLoading}
                    />
                </div>
            </div>

            {!isLoading ? (
                <table className="min-w-full bg-white rounded-lg shadow-lg overflow-hidden border-2 border-gray-200">
                    <thead className="bg-gray-200">
                        <tr>
                            {/* <th className="px-4 py-2 text-left font-bold text-blue-600">Dispatch Record ID</th>
                            <th className="px-4 py-2 text-left font-bold text-blue-600">Ticket ID</th> */}
                            <th className="px-4 py-2 text-left font-bold text-blue-600">Type</th>
                            <th className="px-4 py-2 text-left font-bold text-blue-600">Start DateTime</th>
                            <th className="px-4 py-2 text-left font-bold text-blue-600">End DateTime</th>
                            <th className="px-4 py-2 text-left font-bold text-blue-600">Comments</th>
                            <th className="px-4 py-2 text-left font-bold text-blue-600">Signature DateTime</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-700">
                        {filteredCalls.map((call) => (
                            <tr key={call.dispatchRecordId} className="border-t">
                                {/* <td className="px-4 py-2">{call.dispatchRecordId}</td>
                                <td className="px-4 py-2">{call.ticketId}</td> */}
                                <td className="px-4 py-2">{call.type}</td>
                                <td className="px-4 py-2">{formatDate(call.startDateTime)}</td>

                                <td className="px-4 py-2">{formatDate(call.endDateTime)}</td>
                                <td className="px-4 py-2">{call.comments}</td>
                                <td className="px-4 py-2">{formatDate(call.signatureDateTime)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <div className="flex justify-center items-center mt-6">
                    <p>Loading...</p>
                </div>
            )}
        </div>
    );
};

export default History;
